import { titleCase } from '@wolfejs/core/utils/string';
import { Badge } from '@wolfejs/ui/Badge/Badge';
import { FormatCurrency } from '@wolfejs/ui/Format/FormatCurrency';
import { Title } from '@wolfejs/ui/Title/Title';
import { UIColors, UISizes } from '@wolfejs/ui/types/UI';
import { DashboardPanel } from '../DashboardPanel';
import type { BalanceInfo } from './types';
import { Spinner } from '@wolfejs/ui/Spinner';

type BalanceCardProps = {
  balanceInfo?: BalanceInfo;
};

export const BalanceCard = ({ balanceInfo }: BalanceCardProps) => {
  return (
    <DashboardPanel className="bg-default-50 dark:bg-default-800 flex flex-1" classNames={{ wrapper: 'p-4' }}>
      <Badge className="mb-3" size={UISizes.xs} color={UIColors.success}>{`${titleCase(
        balanceInfo?.balanceType || 'Available'
      )} Balance`}</Badge>
      <Title as={'h2'} className="mb-0">
      {
        balanceInfo?.loading ? <Spinner size="26" /> :
        <FormatCurrency
          prefix="$"
          decimalScale={2}
          numberFormatBaseProps={{ value: balanceInfo?.amount || 0, displayType: 'text' }}
        />
      }
      </Title>
    </DashboardPanel>
  );
};
